import { Component, EventEmitter, Input, Output } from "@angular/core";
import { MenuItem, PrimeIcons } from "primeng/api";

export type Payment = {
  aVista: boolean;
  meio: string;
  descricaoMeio: string;
  valor: number | string;
  id?: string;
};

@Component({
  selector: "app-payment-card",
  templateUrl: "./payment-card.component.html",
  styleUrls: ["./payment-card.component.scss"]
})
export class PaymentCardComponent {
  @Output() remove = new EventEmitter<string>();
  @Output() edit = new EventEmitter<string>();
  @Input() payment?: Payment;

  options: MenuItem[] = [
    {
      icon: PrimeIcons.TRASH,
      command: () => {
        this.remove.emit(this.payment?.id);
      }
    },
    {
      icon: PrimeIcons.PENCIL,
      command: () => {
        this.edit.emit(this.payment?.id);
      }
    }
  ];
}
